module.exports = __webpack_public_path__ + "img/img-f1306c26.2418a928.png";